import { useRef, useState } from 'react';
import { api } from '../config/api';

/**
 * Campo de imagen/foto con subida al hacer clic.
 * Al hacer clic se abre el selector de archivos, sube a UPLOAD_DIR y asigna la URL.
 */
function ImageUploadField({ label, value, onChange, placeholder = 'https://... o clic para subir', token }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleClick = () => {
    if (!token) {
      alert('Debes iniciar sesión para subir archivos');
      return;
    }
    inputRef.current?.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!/^image\//.test(file.type)) {
      alert('Solo se permiten imágenes (jpeg, png, gif, webp, svg)');
      return;
    }
    setUploading(true);
    try {
      const { url } = await api.uploadImage(file, token);
      onChange(url);
    } catch (err) {
      alert(err?.message || 'Error al subir la imagen');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      <div className="flex gap-3 items-center">
        <input
          type="file"
          ref={inputRef}
          onChange={handleFileChange}
          accept="image/jpeg,image/png,image/gif,image/webp,image/svg+xml"
          className="hidden"
        />
        <input
          type="url"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          onClick={handleClick}
          placeholder={placeholder}
          readOnly={uploading}
          className="flex-1 px-3 py-2 border rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 focus:bg-white focus:ring-2 focus:ring-blue-500"
          title="Clic para subir imagen o pegar URL"
        />
        <button
          type="button"
          onClick={handleClick}
          disabled={uploading}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 text-sm font-medium whitespace-nowrap"
        >
          {uploading ? 'Subiendo...' : '📤 Subir'}
        </button>
        {value && (
          <img src={value} alt="" className="w-16 h-16 object-cover rounded-lg border flex-shrink-0" onError={(e) => { e.target.style.display = 'none'; }} />
        )}
      </div>
    </div>
  );
}

export default ImageUploadField;
